import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const pickupAddressMachine =
  createTripArrayFieldMachine('pickupAddress');
